/**
 * Licensing Context Provider Component
 */

import * as React from 'react';

import { TrackLicensingContext } from './';
import { ITrackLicensingContext, SetTrackHandler, SetUsagesHandler } from './types';

export class TrackLicensingContextProvider extends React.Component<{}, ITrackLicensingContext> {
  constructor(props) {
    super(props);

    this.state = {
      clearAll: this.clearAll,
      setUsages: this.setUsages,
      setTrack: this.setTrack,
    };
  }

  clearAll = () => {
    this.setState({
      trackSlug: undefined,
      usages: undefined,
    });
  }

  clearTrack = () => {
    this.setState({ trackSlug: undefined });
  }

  clearUsages = () => {
    this.setState({ usages: undefined });
  }

  setUsages: SetUsagesHandler = (usages) => {
    // Can only set usages when a track was already selected
    if (!!this.state.trackSlug) {
      setTimeout(() => {
        this.setState({ usages });
      }, 2000);
    }
  }

  setTrack: SetTrackHandler = (trackSlug) => {
    this.setState({ trackSlug });
  }

  render() {
    return (
      <TrackLicensingContext.Provider value={this.state}>
        {this.props.children}
      </TrackLicensingContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/trackLicensing/provider.tsx